// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  "apiKey": import.meta.env.VITE_FIREBASE_API_KEY,
  "authDomain": import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  "databaseURL": import.meta.env.VITE_FIREBASE_DATABASE_URL,
  "projectId": import.meta.env.VITE_FIREBASE_PROJECT_ID,
  "storageBucket": import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  "messagingSenderId": import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  "appId": import.meta.env.VITE_FIREBASE_APP_ID,
  "measurementId": import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics
export const analytics = getAnalytics(app);

// Initialize Realtime Database
export const database = getDatabase(app);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Auth
export const auth = getAuth(app);

export default app;
